module.exports = __webpack_public_path__ + "static/img/hs_ct.bd225d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/hs_ct.png
// module id = bOjD
// module chunks = 1